import { refreshAccessSurfaces } from '@/stores/accessSync'
import { useAuthStore } from '@/stores/authStore'
import { useProjectsStore } from '@/stores/projectsStore'
import { configureSessionPort } from './sessionPort'

/**
 * Wire the transport's session port to the concrete stores. Called once at startup
 * (before React mounts) so the transport can fire session side-effects and read
 * root-tenant context without importing the stores itself — which is what keeps the
 * api ⇄ store import cycles broken. This module sits above both layers, so it can
 * depend on each without re-introducing a cycle.
 */
export const registerSessionPort = (): void => {
	configureSessionPort({
		onUnauthorized: () => {
			if (window.location.pathname !== '/login') {
				useAuthStore.getState().clearAuthState()
				// Hard redirect so it works even when RouterProvider isn't mounted (e.g. initial-load 401)
				window.location.replace('/login')
			}
		},
		onProjectAccessDenied: (orgId, tenantId) => {
			useAuthStore.getState().setCurrentOrganizationId(orgId)
			useAuthStore.getState().setCurrentTenant('')
			window.location.replace(
				`/orgs/${encodeURIComponent(orgId)}/projects/${encodeURIComponent(tenantId)}/access-denied`,
			)
		},
		getRootTenantId: () => useProjectsStore.getState().rootTenantId || '',
		onAccessAffectingMutation: refreshAccessSurfaces,
	})
}
